import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import * as moment from 'moment-timezone';
import { Observable } from 'rxjs';

import { CoachSettingsGeneralCertificatesController } from 'presentation/page/settings/coach-settings/coach-settings-general/coach-settings-general-certificates/coach-settings-general-certificates.controller';

import { CoachSettingsGeneralFormController } from '../coach-settings-general-form.controller';

@Component({
	selector: 'spr-coach-settings-general-certificates',
	templateUrl: './coach-settings-general-certificates.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [
		CoachSettingsGeneralCertificatesController,
		CoachSettingsGeneralFormController,
	],
	host: {
		class: 'flex flex-col h-full items-center space-y-3',
	},
})
export class CoachSettingsGeneralCertificatesComponent {
	public calendarLocale$: Observable<any>;
	public referenceDateRange: string;
	public certificatesArray: FormArray;
	public newCertificate: FormGroup;
	public form: FormGroup;

	@Input()
	public set certificateForm(form: FormGroup) {
		this.certificatesArray = form.get('certificates') as FormArray;
		this.newCertificate = form.get('newCertificate') as FormGroup;
		this.form = form;
	}

	constructor(public controller: CoachSettingsGeneralCertificatesController) {
		this.calendarLocale$ = controller.calendarLocale$;
		const referenceMaxYear = moment().year();
		const referenceMinYear = moment().subtract(70, 'year').year();
		this.referenceDateRange = `${referenceMinYear}:${referenceMaxYear}`;
	}

	public onAddCertificateClick() {
		this.controller.addCertificate(this.form);
	}

	public onRemoveCertificateClick(index: number) {
		this.controller.removeCertificate(index, this.form);
	}
}
